<template>
  <d-modal @close="handleClose" size="lg">
    <d-modal-header>
      <d-modal-title>
        Stan zamówienia z {{ evidenceData.updated_at.split('T').map(item => item.split('.')[0]).join(' ') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-0">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
              <th scope="col" class="border-0 pl-4">Nazwa produktu</th>
              <th scope="col" class="border-0" style="width: 120px;">Ilość</th>
              <th scope="col" class="border-0" style="width: 140px;">Status</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(product, index) of evidenceData.products">
            <tr :key="'evidence-product-' + index">
                <td
                  :key="'evidence-product-col-1-' + index"
                  class="align-middle pl-4">
                    {{ product.product_name }}<br>
                    <small><strong>Kod:</strong> {{ product.product_code }}</small>
                </td>
                <td
                  :key="'evidence-product-col-2-' + index"
                  class="align-middle">
                    {{ product.quantity }} szt.
                </td>
                <td
                  :key="'evidence-product-col-3-' + index"
                  class="align-middle">
                    <span
                      v-if="product.status === 'DONE'"
                      class="text-success">
                      Gotowe
                    </span>
                    <span
                      v-if="product.status === 'IN_PROGRESS'"
                      class="text-warning">
                      W toku
                    </span>
                </td>
            </tr>
            <tr
              v-if="product.processes && product.processes.length"
              :key="'evidence-product-elements-' + index">
              <td colspan="3">
                <d-card class="p-3 pb-0 mt-2 mb-2">
                  <table class="table table-sm mb-0">
                    <thead>
                      <tr>
                        <th>Proces</th>
                        <th style="width: 105px;">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(process, subindex) of product.processes"
                        :key="'evidence-product-elements-' + index + '-process-' + subindex">
                        <td>
                          <strong>{{ process.process_name }}</strong><br>
                          <small
                            v-for="(item, subsubindex) of process.items"
                            :key="'evidence-product-elements-' + index + '-process-' + subindex + '-item-' + subsubindex"
                            class="d-flex">
                            <span class="d-block w-50">
                              {{ item.user_name }}
                            </span>
                            <span class="d-block w-50">
                              wykonano: {{ item.quantity_done }} z {{ item.quantity }} szt.
                            </span>
                          </small>
                        </td>
                        <td>
                          <span
                            v-if="process.status === 'DONE'"
                            class="text-success">
                            Gotowe
                          </span>
                          <span
                            v-if="process.status === 'IN_PROGRESS'"
                            class="text-warning">
                            W toku
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </d-card>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  name: 'order-evidence-popup',
  props: [
    'evidenceData'
  ],
  methods: {
    handleClose () {
      this.$bus.$emit('close-order-evidence-popup');
    }
  }
}
</script>
